import React, { memo } from 'react';
import styles from './DataTableFilterDrawerFooter.module.scss';

interface DataTableFilterDrawerFooterProps {
    onSave: () => void;
    onClearAll: () => void;
    saveDisabled?: boolean;
    saveText?: string;
    cancelText?: string;
}

const DataTableFilterDrawerFooter: React.FC<DataTableFilterDrawerFooterProps> = ({
    onSave,
    onClearAll,
    saveDisabled = false,
    saveText = 'Save',
    cancelText = 'Clear All',
}) => {
    return (
        <div className={styles.Footer}>
            <div className={styles.PrimaryActions}>
                <button className={styles.CancelButton} onClick={onClearAll} type="button" disabled={saveDisabled}>
                    {cancelText}
                </button>
                <button className={styles.SaveButton} onClick={onSave} disabled={saveDisabled} type="button">
                    {saveText}
                </button>
            </div>
        </div>
    );
};

export default memo(DataTableFilterDrawerFooter);
